import React from "react";
import { useTranslation } from "react-i18next";
import { StyledMarkets } from "./MarketsStyle";
import { appStore } from "../../stores/appStore";

const Markets = ({ marketsList, selectMarketId, onSelectMarket }) => {
  const { t } = useTranslation("General");

  const {
    generalConfig
  } = appStore((state) => ({
    generalConfig: state.generalConfig
  }));

  return (
    <React.Fragment>
      <div className="w-100 mb-3 mt-2 px-2">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-start">
            {marketsList.map(
              (market) =>
                market.isDefault && (
                  <div
                    className="flex-fill d-grid p-1 text-center"
                    key={market.marketId}
                  >
                    <StyledMarkets selected={selectMarketId === market.marketId}
                      className={
                        selectMarketId === market.marketId
                          ? "btn btn-sm border border-1 bg-secondary text-white fw-bold rounded market-btn overflow-hidden"
                          : "overflow-hidden market-btn rounded btn btn-sm border border-1 text-black"
                      }
                      onClick={() => onSelectMarket(market.marketId)}
                    >
                      {t(`${market.marketName}`)}
                    </StyledMarkets>
                  </div>
                )
            )}
          </div>
          <div className="flex-fill d-grid p-1 justify-content-end">
            <select
              value={selectMarketId < 5 ? "" : selectMarketId}
              className="bg-white border border-1 ps-1 rounded fw-bold cursor"
              onChange={($event) => onSelectMarket(+$event.target.value)}
            >
              <option value="" disabled>
                {t("More")}
              </option>
              {marketsList.map((market, index) => (
                <React.Fragment key={index}>
                  {market.marketId === 5 && generalConfig?.hideSuperOddsSection &&(
                    <option value={market.marketId}>{t(`${market.marketName}`)}</option>
                  )}
                  {market.marketId > 5 && (
                    <option value={market.marketId}>{t(`${market.marketName}`)}</option>
                  )}
                </React.Fragment>
              ))}
            </select>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Markets;
